module.exports = __webpack_public_path__ + "static/img/mark5-ecC1u8V4.5f08c05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/mark5-ecC1u8V4.png
// module id = //4X
// module chunks = 16